module.exports = __webpack_public_path__ + "static/media/em-90.47fdd2b3.png";